"use client";

import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { PlusIcon } from "@/components/icons/Plus";
import styles from "./LoadMoreButton.module.css";

export type LoadMoreButtonProps = Omit<
	ComponentProps<"button">,
	"children" | "onClick" | "type"
> & {
	text: string;
	action?: () => void;
};

export const LoadMoreButton = ({
	text,
	action,
	className,
	...props
}: LoadMoreButtonProps) => {
	return (
		<button
			type="button"
			onClick={action}
			className={clsx(styles.loadMoreButton, className)}
			{...props}
		>
			<PlusIcon />
			<span>{text}</span>
		</button>
	);
};
